import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'

interface HeadingProps {
    children: string
}

const Heading: FC<HeadingProps> = ({ children }) => {
    return (
        <Typography.Menu
            size="small"
            numberOfLines={1}
            style={{ flexShrink: 1, color: ColorEnum.JET_100, textTransform: 'uppercase' }}
        >
            {children}
        </Typography.Menu>
    )
}

export default Heading
